"use client";
import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import useAuth from "@/contexts/auth-context";
import ICoverageArea from "@/interfaces/coverage-area.interface";
import { CoverageAreaMessages } from "@/messages/coverage-area/coverage-area.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { CoverageAreaTableRow } from "./row";
import { COVERAGE_AREA_TABLE_COLUMNS } from "../../constants";

interface CoverageAreaTableProps {
  data: PaginatedResponse<ICoverageArea>;
  pagination: Pagination;
  messages: CoverageAreaMessages;
}

export function CoverageAreaTable({ data, pagination, messages }: CoverageAreaTableProps) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const { user: currentUser } = useAuth();
  const columns = COVERAGE_AREA_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell
                  key={`${index} - ${label}`}
                  align={index >= 4 && index <= 8 ? "center" : "left"}
                >
                  {label}
                </HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {currentUser &&
              data.items.map((coverageArea, index) => (
                <CoverageAreaTableRow
                  key={`${index} - ${coverageArea.id}`}
                  index={index}
                  coverageArea={coverageArea}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, pageNumber) => changePage(pageNumber)}
      />
    </>
  );
}
